module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cropper-modal"
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-content clearfix"
  }, [_c('div', {
    staticClass: "img-clip-wrap"
  }, [_c('div', {
    staticClass: "container-bg"
  }, [_c('div', {
    staticClass: "img-container"
  }, [_c('img', {
    attrs: {
      "id": "clip_src_img",
      "src": _vm.img
    },
    on: {
      "load": _vm.srcImgLoaded
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shadow-box"
  }), _vm._v(" "), _c('Select-Box', {
    ref: "box",
    attrs: {
      "srcSize": _vm.imgSize,
      "ratio": _vm.ratio,
      "img": _vm.img
    },
    on: {
      "selectEnd": _vm.selectEnd,
      "selectChange": _vm.selectChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "reset-img"
  }, [_c('i', {
    staticClass: "icon-reset"
  }), _vm._v(" "), _c('span', [_vm._v("select image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file_input",
      "accept": "image/png,image/jpg,image/gif"
    },
    on: {
      "change": _vm.fileChange
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "img-preview-wrap"
  }, [_c('div', {
    staticClass: "pre-container"
  }, [_c('img', {
    attrs: {
      "id": "clip_res_img",
      "src": _vm.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pre-info"
  }, [_vm._v("preview")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('a', {
    staticClass: "modal-btn btn-confirm",
    attrs: {
      "href": _vm.clipData,
      "download": "crop.jpg"
    }
  }, [_vm._v("clip")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-head"
  }, [_c('div', {
    staticClass: "head-wrap"
  }, [_vm._v("title")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-230e4956"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomCropper.vue
// module id = 12
// module chunks = 0